import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { useAppSelector } from './redux';
import { selectPreOrdersActions, selectProductItems, selectProducts } from '../../modules/selectors';
import { BEURS_2024_PREORDER_TYPE } from '../../api/tradeFair/useBooths';
import { selectItems } from '../../modules/products/productsSelectors';
import { object } from 'prop-types';

export const useProductWeightsPreOrders = () => {
	const preOrdersActions = useAppSelector(state => selectPreOrdersActions(state, 1)); //todo 1 -> const
	const products = useAppSelector(selectProductItems);
	// console.log('preOrdersActions', preOrdersActions);
	// console.log('products', products);
	const totalWeight = useMemo(() => {
		if (!preOrdersActions || !products || !Object.values(products).length) return 0;
		return preOrdersActions.reduce((total, action) => {
			if (!action.articles || !action.quantities) return total;
			    const actionWeight = action.articles.reduce((actionTotal, article) => {
				const quantity = action.quantities?.[article.id] ?? 0;
				const weight = products[article.id]?.weight ?? 0;
				return Math.round((actionTotal + (quantity * weight))*100) / 100;
			}, 0);
			return total + actionWeight;
		}, 0);
	}, [preOrdersActions, products]);
	return totalWeight;
};
